import React, { FC } from "react";
import { useQuery } from "react-query";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core";
import { AvatarWithStatus } from "../../../../components/AvatarWithStatus";
import IconButton from "../../../../components/IconButton";
import FontIcon from "../../../../components/FontIcon";
import { AdapterLink } from "../../../../components/Adopter";
import useStudentsQueries from "../../hooks/useManagedStudentsQueries";
import { IStudentProfileWidget } from "../../types";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
  },
  name: {
    fontSize: 14,
    color: "#192130",
    fontWeight: 500,
    marginLeft: 10,
  },
  actionButton: {
    marginLeft: 7,
    padding: 7,
    "& .MuiIcon-root": {
      fontSize: 12,
    },
  },
  emailContainer: {
    position: "relative",
    marginTop: 4,
    marginLeft: 5,
  },
  unreadMessage: {
    "&::before": {
      content: "''",
      position: "absolute",
      top: 1,
      right: 4,
      height: 9,
      width: 9,
      borderRadius: "50%",
      border: "1px solid #fff",
      backgroundColor: theme.palette.error.main,
    },
  },
  email: {
    color: "#5351FB",
    transition: "color 0.2s ease-out",
    "&:hover": {
      color: "#4140c2",
      cursor: "pointer",
    },
  },
}));

export const StudentProfileWidget: FC<IStudentProfileWidget> = ({
  id,
  actionButtonType,
  onActionButtonClick,
  hasUnreadMessage,
}) => {
  const { fetchStudentData } = useStudentsQueries();
  const { data: { data: student = {} } = {} } = useQuery<any>(
    `${"studentData" + id}`,
    () => fetchStudentData(id),
  );

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AvatarWithStatus
        src={student.photo?.preview}
        alt="Student Photo"
        size={66}
        borderWidth={2}
      />
      <div className={classes.name}>{student.name}</div>
      {onActionButtonClick && actionButtonType === "edit" && (
        <IconButton
          color={"edit"}
          className={classes.actionButton}
          onClick={onActionButtonClick}
        >
          <FontIcon name={"edit"} />
        </IconButton>
      )}
      {onActionButtonClick && actionButtonType === "email" && (
        <div
          className={clsx(
            classes.emailContainer,
            hasUnreadMessage && classes.unreadMessage,
          )}
        >
          <AdapterLink to={onActionButtonClick()} underline={"none"}>
            <FontIcon name={"email"} className={classes.email} />
          </AdapterLink>
        </div>
      )}
    </div>
  );
};
